import { gql } from "@apollo/client";

import { animalFragment } from "api/MyLivestock/Animal/fragment";

export const GET_SUPPORTED_SYSTEMS = gql`
  query GetSupportedSystemsCustomImport($farm: Int!, $systemType: String, $isAutomatedSystem: Boolean) {
    integrationSystems(farm: $farm, systemType: $systemType, isAutomatedSystem: $isAutomatedSystem) {
      id
      name
      logo
    }
  }
`;

export const GET_IMPORT_RESULT = gql`
  query ImportResult($task: String!) {
    importResult(task: $task) {
      isDone
      failedAnimalsUrl
      failedActivitiesUrl
      errorRows
      importedAnimalsCount
      createdGroupsCount
      updatedAnimals
      animals {
        ...animalFragment
      }
      importedActivitiesCount
    }
  }
  ${animalFragment}
`;

export const GET_BATCH_UPLOAD_FORMATS = gql`
  query GetBatchUploadFormats($businessUnitId: Int!) {
    batchUploadFormats(businessUnitId: $businessUnitId) {
      animalTypes {
        id
      }
      activityTemplateId
      columns {
        isRequired
        label
        name
      }
    }
  }
`;
